export interface HtmlEditorCompenentConfig {
    placeholder?: string;
    cssStyle?: { [key: string]: any };
    cssClass?: string;
}
